document.addEventListener('alpine:init', function () {
    Alpine.data('heroBanner', function () {
        return {
            extraMargin: 0,
            calculateHeight: function () {
                if (!this.$refs.sidebar || !this.$refs.textContent)
                    return;
                if (this.$store.app.lg) {
                    // height offset is the negative 'top' value for the sidebar.
                    var heightOffset = 288;
                    var sidebarHeight = Math.ceil(this.$refs.sidebar.offsetHeight);
                    var textContentHeight = Math.ceil(this.$refs.textContent.offsetHeight);
                    var totalHeight = sidebarHeight - heightOffset;
                    this.$refs.textContent.style.height = "".concat(Math.max(textContentHeight, totalHeight), "px");
                }
                else {
                    this.extraMargin = 0;
                }
            },
        };
    });
});
